import ApiRequests from "../apiRequests";

class BrandService extends ApiRequests {
  constructor() {
    super("brands");
  }
}

export default BrandService;
